// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PlusBadge":"bep_a bib_rj bib_rk bib_vh bib_eb bib_vf bib_gs bib_kh"};